import React from "react";
import { Redirect } from "react-router-dom";
import { isMdScreen } from "utils";

const settings = {
  activeLayout: "layout1",
  layout1Settings: {
    topbar: {
      show: true,
    },
    leftSidebar: {
      show: true,
      mode: isMdScreen() ? "close" : "full",
    },
  },
  likeDislikeButtons: { show: false },
};

const CertificatesRoutes = [
  {
    exact: true,
    path: "/Certificates",
    component: () => <Redirect to="/payroll/certifications" />,
    settings,
  },
];

export default CertificatesRoutes;
